import type { FC, PropsWithChildren, ReactElement } from 'react';

import { ChatRibbonConnected } from '../../components/chat/chatRibbon/ChatRibbonConnected';
import { SessionBalanceConnected } from '../../components/compliance/SessionBalanceConnected';
import { DraggableChipConnected } from '../../components/dragAndDrop/DraggableChipConnected';
import { Fullscreen } from '../../components/fullscreen/Fullscreen';
import { DrawerRoot } from '../../components/game/drawer/root/DrawerRoot';
import { MiniLobbyConnected } from '../../components/miniLobby/MiniLobbyConnected';
import { OverlayConnected } from '../../components/overlay/overlay/OverlayConnected';
import { PromotionSelector } from '../../components/promotions/PromotionSelector';
import { VolumeRestorer } from '../../components/settings/VolumeRestorer';
import { ToastContainerConnected } from '../../components/toast/ToastContainerConnected';
import { TooltipRoot } from '../../components/tooltip/TooltipRoot';
import { WinnersListConnected } from '../../components/winners/winnersListConnected';
import { useInitializationSlice } from '../../store/slices/initialization/selectors';
import { BackToGameConnected } from '../backToGame/BackToGameConnected';
import { SessionExpiredPopupConnected } from '../popup/sessionExpired/SessionExpiredPopupConnected';
import { TableClosedPopupConnected } from '../popup/tableClosed/TableClosedPopupConnected';

import styles from './GameBody.module.css';

export const GameBody: FC<PropsWithChildren> = ({ children }): ReactElement => {
  const isReadyToRender = useInitializationSlice.getIsReadyToRender();

  return (
    <>
      <SessionExpiredPopupConnected />
      <TableClosedPopupConnected />
      {isReadyToRender ? (
        <div className={styles.gameBody}>
          <div className={styles.gameBody__container}>
            {children}
            <WinnersListConnected key="Winners" />
            <SessionBalanceConnected />
            <ToastContainerConnected />
            <ChatRibbonConnected />
            <DraggableChipConnected />
            <PromotionSelector />
            <OverlayConnected />
          </div>
          <DrawerRoot />
          <TooltipRoot />
          <VolumeRestorer />
          <MiniLobbyConnected />
          <BackToGameConnected />
        </div>
      ) : null}
      <Fullscreen isReadyToRender={isReadyToRender} />
    </>
  );
};
